// @flow
import React, { Component } from 'react';
import { Text, asField } from 'informed';
import ReactTooltip from 'react-tooltip';
import moment from 'moment';

/*
  To use with React Table, pass in field name, row item, and nullable if want 'Ongoing' checkbox
  To use as standalone input, pass in field name, item={{ field }} as attr (see GeneralInfo for ex.)
  To initialize the text as null (rather than the current date) in the event that a previous
  value doesn't exist, pass in initEmpty.
  To disable field, use the disabled prop.

  Note: implemented before ValidateText so messier implementation maybe
*/

type Props = {
  field: string,
  fieldState: Object,
  fieldApi: Object,
  nullable: bool,
  item: Object,
  initEmpty: bool,
  disabled: ?bool,
}

type State = {
  checked: bool,
}

class DateText extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const {
      field, item, nullable, initEmpty,
    } = this.props;
    this.state = {
      checked: nullable && !item[field] && !initEmpty,
    };
  }

  toggleCheck = () => {
    if (!this.state.checked) {
      this.props.fieldApi.setValue('');
    } else {
      this.props.fieldApi.setValue(moment().format());
    }
    this.props.fieldApi.setTouched(true);
    this.setState({
      checked: !this.state.checked,
    });
  }

  render() {
    const {
      field, fieldState, item, nullable, initEmpty, ...props
    } = this.props;
    let initialDateValue;
    if (initEmpty) {
      initialDateValue = item[field] ? moment(item[field]).format() : null;
    } else {
      initialDateValue = item[field] ? moment(item[field]).format() : moment().format();
    }

    return (
      <span>
        <Text
          field={field}
          initialValue={this.state.checked ? '' : initialDateValue}
          disabled={this.state.checked || this.props.disabled}
          style={fieldState.error && { border: '2px solid #FF6363', outline: '0px' }}
          data-tip
          data-for={field}
          placeholder={'DD-MM-YYYY'}
          {...props}
        />
        {nullable
          && <div>
            <input type='checkbox' onClick={this.toggleCheck} defaultChecked={this.state.checked} />
              Ongoing
          </div>
        }
        {fieldState.error
          && <ReactTooltip id={field} type='error' effect='solid'>
            <span>Invalid format, please use DD-MM-YYYY</span>
          </ReactTooltip>
        }
      </span>
    );
  }
}

const DateTextComponent = asField(DateText);

// Accepts DD-MM-YYYY from 1900-2199, days and months can omit leading 0's
const validate = value => (/^((0?[1-9]|[12][0-9]|3[01])-(0?[1-9]|1[012])-(19|20|21)\d\d)?$/.test(value) ? null : 'Error');

type WrapperProps = {
  field: string,
  nullable?: bool,
  item: Object,
  initEmpty?: bool,
}

class DateTextWrapper extends Component<WrapperProps> {
  render() {
    const {
      field, nullable, item, initEmpty, ...rest
    } = this.props;
    return <DateTextComponent
      validate={validate}
      validateOnChange
      field={field}
      nullable={nullable}
      item={item}
      initEmpty={initEmpty}
      {...rest}
    />;
  }
}

export default DateTextWrapper;



// WEBPACK FOOTER //
// ./client/src/components/DateText.jsx